import { render, staticRenderFns } from "./ImageLazy.vue?vue&type=template&id=2ac57483&scoped=true&lang=html&"
import script from "./ImageLazy.vue?vue&type=script&lang=js&"
export * from "./ImageLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac57483",
  null
  
)

export default component.exports